import {create} from 'zustand';
import BandeauxAPI from '../services/BandeauxAPI.tsx'

interface BannersStateInterface {
    banners: array;
    bannersLeft: array;
    bannersRight: array;
    loaded: boolean;
    fetch: () => void;
    setLoaded: (loaded: boolean) => void;
}

export const useStoreBanners = create<BannersStateInterface>((set, get) => ({
    banners: [],
    bannersLeft: [],
    bannersRight: [],
    loaded: false,
    fetch: async () => {
        if (!get().loaded) {
            await BandeauxAPI.getBandeaux().then(({data: banners}): void => {
                set({
                    banners,
                    loaded: true,
                })

                if (banners.length > 0) {
                    set({
                        bannersLeft: banners.filter(
                            (banner) => banner.side === 'left',
                        ),
                        bannersRight: banners.filter(
                            (banner) => banner.side === 'right',
                        ),
                    })
                }
            })
        }

    },
    setLoaded: (loaded) => set({loaded})
}))
